// @owners { team: patient-health }
import { type Medication } from '~shared/features/my-meds/types';
import { type MedicationTakenEvent, type ReminderSequence } from '~shared/types';
import { type PendingMedicationTakenEvent } from '~shared/types/medReminders'; // TODO: this doesn't match medication key exactly since we don't take into
// account rx_number, but will have to do for now until reminders get explicitly
// associated with prescriptions

export default function getMedicationKey(
  // @ts-expect-error TS(2339): Property 'gcn_seqno' does not exist on type 'Medication | ReminderSequence | MedicationTakenEvent | ... (Delete me to see the full error)
  { gcn_seqno, gcnSeqno, ndc }: Medication | ReminderSequence | MedicationTakenEvent | PendingMedicationTakenEvent,
  user_id: number | null | undefined,
): string {
  return `${gcn_seqno || gcnSeqno || ndc || ''}-${user_id?.toString() || ''}`;
}
